import React from 'react';
import styled from 'styled-components';
import UpKeepIcon from '../../assets/UpKeepIcon';

const sprites = {
  custom: '/sprites/custom.svg',
};

const Icon = ({
  id,
  className,
  width,
  height,
  fillColor,
  strokeColor,
  styles,
  role,
}) => {
  if (!id) return null;

  if (id === 'upkeep' || id === 'upkeep-icon') {
    return <UpKeepIcon color={fillColor} />;
  }

  // convert fa id to custom id
  const pattern = /fa-(regular|solid)\sfa-(\w+)/;
  const formatattedId = id.replace(pattern, '$2');

  return (
    <Container
      width={width}
      height={height}
      className={className}
      styles={styles}
      fillColor={fillColor}
      strokeColor={strokeColor}
      role={role || 'presentation'}
    >
      <use href={`${sprites.custom}#${formatattedId}`} />
    </Container>
  );
};

export default Icon;

const Container = styled.svg`
  width: ${props => props.width || 'auto'};
  height: ${props => props.height || 'auto'};
  ${props => props.styles}
  use {
    width: 100%;
    height: 100%;
    fill: ${props => props?.fillColor || 'inherit'};
    stroke: ${props => props?.strokeColor || 'inherit'};
    color: ${props => props?.fillColor || 'inherit'};
  }
`;
